import { ExternalLink, MapPin } from "lucide-react";
import { HOTEL, IMAGES } from "@/constants/hotelData";
import Reveal from "@/components/Reveal";

export default function LocationSection() {
  return (
    <section id="location" className="py-24 sm:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <div>
          <Reveal>
            <p className="mb-4 text-[10px] font-medium uppercase tracking-[0.34em] text-gold sm:text-xs">Find Us</p>
            <h2 className="font-serif text-3xl leading-snug tracking-tight text-cream sm:text-4xl lg:text-[2.75rem]">
              On Ghorasahan Road,
              <br />
              <span className="gold-gradient-text italic">right by the Overbridge</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 flex items-start gap-3 text-base font-light leading-relaxed text-stone-300">
              <MapPin className="mt-1 h-5 w-5 shrink-0 text-gold" />
              {HOTEL.address}
            </p>
            <p className="mt-4 text-sm font-light leading-relaxed text-stone-400">
              Easy to find, easy to reach — ask any auto or taxi for "Hotel Raj,
              Dhaka Overbridge" and they will know the way.
            </p>
            <a
              href={HOTEL.mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="get-directions-button"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink transition-all duration-300 hover:bg-goldlight hover:shadow-[0_0_28px_rgba(212,175,55,0.4)]"
            >
              Get Directions <ExternalLink className="h-4 w-4" />
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <div className="relative">
            <img
              src={IMAGES.hero}
              alt="Hotel Raj in the evening"
              className="aspect-[4/3] w-full rounded-2xl border border-gold/20 object-cover"
              data-testid="location-image"
            />
            <div className="glass absolute -bottom-6 left-6 right-6 rounded-xl p-5 sm:left-8 sm:right-auto sm:max-w-sm">
              <div className="text-[10px] uppercase tracking-[0.24em] text-goldlight/80">Address</div>
              <div className="mt-2 text-sm leading-relaxed text-cream">{HOTEL.address}</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
